import React, { useEffect, useState } from "react";
import ReplyComment from "./ReplyComment";
import * as actions from "../../Comment/_redux/commentAction";
import { useDispatch, useSelector } from "react-redux";
import {
    socialShare,
    timeFormatter,
    setHeightLayout,
    htmlToText
} from "./../helpers";
import { useTranslation } from "react-i18next";
import HTMLEllipsis from "react-lines-ellipsis/lib/html";
import TippyAction from "./TippyAction";

const FeedbackItem = ({ data, parentData, totalReply, type, lastIndex }) => {
    // __REDUX
    const { currentState } = useSelector(state => ({
        currentState: state.comment
    }));
    const { commentSetting } = currentState;
    const [isLike, setIsLike] = useState(false);
    // initial dispatch
    const dispatch = useDispatch();

    // __STATE
    const [isShowReply, setIsShowReply] = useState(false);
    const [showMore, setShowMore] = useState(false);
    // tranlation
    const { t } = useTranslation();
    // __EFFECT
    // effect để change height của iframe mỗi khi có thay đổi dependency
    useEffect(() => {
        setHeightLayout(25);
    }, [isShowReply]);
    // FUNCTION HANDLE
    const onCloseAndOpenReyplyAnswer = () => {
        setIsShowReply(!isShowReply);
    };
    const onLike = function(data) {
        let request = {
            CommentId: data.commentId,
            categoryId: commentSetting.categoryId,
            objectId: commentSetting.objectId,
            websiteId: commentSetting.websiteId
        };
        dispatch(actions.commentLike(request));
    };
    const onUnLike = function(data) {
        let request = {
            CommentId: data.commentId,
            categoryId: commentSetting.categoryId,
            objectId: commentSetting.objectId,
            websiteId: commentSetting.websiteId
        };
        dispatch(actions.commentUnLike(request));
    };
    // const onHandleLikeAndUnlike = () => {
    //     window.parent.postMessage(
    //         { onSetCookie: { [`vnn_cmt_${data.commentId}`]: true } },
    //         "*"
    //     );
    //     if (
    //         !commentSetting.maxLimitedLikeAndUnlike[`vnn_cmt_${data.commentId}`]
    //     ) {
    //         if (isLike) {
    //             setIsLike(false);
    //             // data.totalLike = data.totalLike - 1;
    //             onHandleActiveVote();
    //             return onUnLike(data);
    //         } else {
    //             setIsLike(true);
    //             // data.totalLike = data.totalLike + 1;
    //             onHandleActiveVote();
    //             return onLike(data);
    //         }
    //     }
    // };

    // effect handle active vote
    // useEffect(() => {
    //     if (
    //         localStorage.getItem(`vnn-active-vote-ID${commentSetting.objectId}`)
    //     ) {
    //         let isEmpty = true;
    //         JSON.parse(
    //             localStorage.getItem(
    //                 `vnn-active-vote-ID${commentSetting.objectId}`
    //             )
    //         ).forEach(item => {
    //             if (item?.commentId == data.commentId) isEmpty = false;
    //         });
    //         if (!isEmpty) setIsLike(true);
    //     }
    // }, []);
    // // function handle active vote
    // const onHandleActiveVote = () => {
    //     let totalVoteActive = localStorage.getItem(
    //         `vnn-active-vote-ID${commentSetting.objectId}`
    //     )
    //         ? JSON.parse(
    //               localStorage.getItem(
    //                   `vnn-active-vote-ID${commentSetting.objectId}`
    //               )
    //           )
    //         : [];
    //     if (!isLike) {
    //         // console.log(data.commentId);
    //         // console.log(commentSetting.objectId);
    //         totalVoteActive.push({
    //             objectId: commentSetting.objectId,
    //             commentId: data.commentId
    //         });
    //         localStorage.setItem(
    //             `vnn-active-vote-ID${commentSetting.objectId}`,
    //             JSON.stringify(totalVoteActive)
    //         );
    //     } else {
    //         totalVoteActive = totalVoteActive.filter(
    //             item => item.commentId !== data.commentId
    //         );
    //         // console.log(totalVoteActive);
    //         if (totalVoteActive.length > 0) {
    //             localStorage.setItem(
    //                 `vnn-active-vote-ID${commentSetting.objectId}`,
    //                 JSON.stringify(totalVoteActive)
    //             );
    //         } else
    //             localStorage.removeItem(
    //                 `vnn-active-vote-ID${commentSetting.objectId}`
    //             );
    //     }
    // };

    const onHandleSeemoreContent = () => {
        setTimeout(() => setHeightLayout(20));
        setShowMore(true);
    };

    return (
        <>
            <div className='user__item relative grid grid-cols-[35px,1fr] gap-[15px] mx-[15px] py-[8px] '>
                <div className=''>
                    {data.avatarUrl ? (
                        <div
                            className='w-[32px] rounded-full h-[32px] bg-no-repeat bg-cover bg-center'
                            style={{
                                backgroundImage: `url(${data.avatarUrl})`
                            }}></div>
                    ) : (
                        <div
                            className='w-[32px] text-[#999] leading-[32px] text-center bg-gray-200 text-[18px]
                        rounded-full h-[32px] bg-no-repeat uppercase bg-cover bg-center'>
                            {data.userName.split("")[0]}
                        </div>
                    )}
                </div>
                <div className='author__dataBinding'>
                    <div>
                        <span
                            style={{
                                color:
                                    commentSetting?.version &&
                                    commentSetting?.version === "2.0.0"
                                        ? commentSetting.commentConfiguration
                                              .themeConfig.userBlock.titleColor
                                        : commentSetting?.theme?.textColor
                            }}
                            className='text-[#2D67AD] mb-[5px] flex items-center text-[16px] font-arial font-semibold font-weight-none sm:font-notosans-bold'>
                            {data.userName}
                        </span>
                        {/* {
                            <span className='reply__to text-[13px] ml-[10px] text-[#999]'>
                                <i className='fa fa-share text-[13px] mr-[5px] '></i>
                                {totalReply.find(
                                    item => item.commentId == data.answerId
                                )?.userName || parentData.userName}
                            </span>
                        } */}
                    </div>
                    <div className='content__wrapper'>
                        <div
                            style={{
                                color:
                                    commentSetting?.version &&
                                    commentSetting?.version === "2.0.0" &&
                                    commentSetting.commentConfiguration
                                        .themeConfig.userBlock.contentColor
                            }}
                            className='__content text-[15px] break-words mb-[5px] text-black'>
                            <span className='text-[#2A2A2A] font-arial md:font-notosans-bold font-bold md:font-normal float-left mr-[4px] '>
                                @
                                {totalReply.find(
                                    item => item.commentId == data.answerId
                                )?.userName || parentData.userName}
                            </span>
                            {showMore ? (
                                <div
                                    className='break-content'
                                    dangerouslySetInnerHTML={{
                                        __html: data.commentContent.replace(
                                            /style="[^"]*"/,
                                            ""
                                        )
                                    }}></div>
                            ) : (
                                <HTMLEllipsis
                                    onClick={onHandleSeemoreContent}
                                    maxLine='3'
                                    unsafeHTML={data.commentContent.replace(
                                        /style="[^"]*"/,
                                        ""
                                    )}
                                    ellipsis={t('message.input.readmore')}
                                    basedOn='letters'
                                    className='content__Ellipsis'
                                />
                            )}
                        </div>
                        <div className='__actions flex justify-between flex-wrap text-[14px] text-[#838383]'>
                            <div className='group-left flex flex-wrap items-center '>
                                <button
                                    onClick={onCloseAndOpenReyplyAnswer}
                                    className='hover:text-[#666] mr-[25px] '>
                                    {t("message.actions.answer")}
                                </button>
                                <TippyAction data={data} />
                            </div>
                            <span className='text-[#838383] text-[14px]'>
                                {timeFormatter(data.createdDate)}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            {isShowReply && (
                <div className="ml-[65px] ">
                    <ReplyComment
                        lastIndex={lastIndex}
                        data={data}
                        parentData={parentData}
                        type={type}
                        setIsShowReply={setIsShowReply}
                    />
                </div>
            )}
        </>
    );
};

export default FeedbackItem;
